import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem('access_token');

  return (
    <div className="notfound-bg">
      <div className="notfound-glow notfound-glow-1" />
      <div className="notfound-glow notfound-glow-2" />

      <main className="notfound-main">
        <img src="/error404.png" alt="Página não encontrada" className="notfound-img" />

        <p className="notfound-subtitle">
          A página que você procura não existe ou foi movida.
        </p>

        <button
          className="notfound-btn"
          onClick={() => navigate(isLoggedIn ? '/dashboard' : '/login')}
        >
          {isLoggedIn ? 'Voltar ao Dashboard' : 'Voltar ao Login'}
          <span className="material-symbols-outlined">arrow_forward</span>
        </button>
      </main>
    </div>
  );
}

export default NotFound;
